import { View, Text } from '@react-pdf/renderer'
import ReportDefinitivoBonoProdPDF from './ReportDefinitivoBonoProdPDF'

export default function DefinitivoBonoProfPDF({
    metadata,
    data,
    title,
    campus,
    startDate,
    endDate,
    ciclo = "",
    escuela = "",
    direccion = "",
    total_grupo_materia = "",
    director=""
}) {
    return (
        <View>
            <ReportDefinitivoBonoProdPDF
                metadata={metadata}
                data={data}
                campus={campus}
                startDate={startDate}
                endDate={endDate}
                ciclo={ciclo}
                escuela={escuela}
                direccion={direccion}
                total_grupo_materia={total_grupo_materia}
                director={director}
                title={title}
            />
            <View
                fixed
                style={{
                    height: 50,
                    position: 'absolute',
                    bottom: 30,
                    left: 0,
                    right: 0,
                    top: 520
                }}
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    }}
                >
                    <View>
                        <Text
                            style={{
                                color: 'gray',
                                fontSize: 11,
                            }}
                            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                        />
                    </View>
                </View>
            </View>
        </View>
    )
}